import {Injectable, OnDestroy} from '@angular/core';
import {CommunicationContentSubstitutionRepository} from './communicationContentSubstitution.repository';
import {
    CommunicationContentSubstitutionDataServiceAdapter
} from './communicationContentSubstitutionDataService.adapter';
import {CommunicationContentSubstitutionModel} from '../../../api/model/communicationContentSubstitution.model';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';

@Injectable()
export class CommunicationContentSubstitutionFindAllService
    extends AbstractFindAllService<CommunicationContentSubstitutionModel, CommunicationContentSubstitutionModel>
    implements OnDestroy{

    constructor(repository: CommunicationContentSubstitutionRepository,
                dataServiceAdapter: CommunicationContentSubstitutionDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
